"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Designer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Editor = _interopRequireDefault(require("redhotmagma-graphics-editor/Components/Editor/Editor"));
var _EditorContainer = _interopRequireDefault(require("redhotmagma-graphics-editor/Components/Editor/EditorContainer"));
var _AlignTargetProvider = require("redhotmagma-visualization/AlignTargetProvider");
var _createCheckerBoardBackground = require("../../../Utils/Styles/createCheckerBoardBackground");
var _excluded = ["children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var mockUploadFunction = function mockUploadFunction(files) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      var dataURL = reader.result;
      resolve([{
        src: dataURL
      }]);
    };
    reader.onerror = reject;
    reader.readAsDataURL(files[0]);
  });
};
var styles = function styles(theme) {
  var _root;
  return {
    root: (_root = {
      flexShrink: 1,
      flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '100%',
      alignItems: 'center'
    }, _defineProperty(_root, theme.breakpoints.down('xs'), {
      minHeight: '150px'
    }), _defineProperty(_root, '&:before', {
      content: "''",
      display: 'block',
      marginTop: 'auto'
    }), _defineProperty(_root, '&:after', {
      content: "''",
      display: 'block',
      marginBottom: 'auto'
    }), _defineProperty(_root, '& > :not(.resize-sensor)', {
      /**
       * The pointer events are passed through in the "main" class of DefaultLayout,
       * but the contained elements may need it (like the Designer and its controls)
       * @see DefaultLayout
       */
      pointerEvents: 'all'
    }), _root),
    checkerBoardBackground: _objectSpread({}, (0, _createCheckerBoardBackground.createCheckerBoardBackground)({
      darkColor: 'rgba(0, 0, 0, 0.1)',
      lightColor: 'rgba(0, 0, 0, 0.01)'
    }))
  };
};
var CustomEditorContainer = (0, _styles.withStyles)({
  closeButton: {
    position: 'absolute',
    top: -20,
    right: -20,
    cursor: 'pointer'
  }
}, {
  name: 'CustomEditorContainer'
})(function (_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_EditorContainer["default"], props, children);
});
var getCustomEditorStyle = function getCustomEditorStyle(_ref2) {
  var hasBorder = _ref2.hasBorder;
  var style = {};
  if (!hasBorder) {
    style.borderWidth = 0;
  }
  return style;
};
var Designer = exports.Designer = function Designer(_ref3) {
  var renderStandardToolbox = _ref3.renderStandardToolbox,
    renderSelectionToolbox = _ref3.renderSelectionToolbox,
    renderInlineToolbox = _ref3.renderInlineToolbox,
    renderRulers = _ref3.renderRulers,
    canvasSize = _ref3.canvasSize,
    classes = _ref3.classes,
    show = _ref3.show,
    selectedColor = _ref3.selectedColor,
    alignTarget = _ref3.alignTarget,
    EditorContainer = _ref3.EditorContainer,
    hideDesigner = _ref3.hideDesigner,
    hasBorder = _ref3.hasBorder,
    useCheckerBoardBackground = _ref3.useCheckerBoardBackground,
    renderInCanvasContainer = _ref3.renderInCanvasContainer;
  var containerReadyHandler = (0, _react.useMemo)(function () {
    return function (_ref4) {
      var container = _ref4.container;
      alignTarget.add(container);
      // it has to be delayed in the next message, when the correct size is already available
      return function () {
        return setTimeout(function () {
          return alignTarget.remove(container);
        });
      };
    };
  }, [alignTarget]);
  var containerUpdateHandler = (0, _react.useMemo)(function () {
    return function () {
      // re-add it on update to trigger the change which updates the offset
      setTimeout(function () {
        alignTarget.add(null);
        alignTarget.remove(null);
      });
    };
  }, [alignTarget]);
  var EditorContainerWithInjectedProps = (0, _react.useMemo)(function () {
    return function (props) {
      return /*#__PURE__*/_react["default"].createElement(EditorContainer, _extends({}, props, {
        onClickClose: hideDesigner
      }));
    };
  }, [hideDesigner]);
  return show && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Editor["default"], {
    style: getCustomEditorStyle({
      hasBorder: hasBorder
    }),
    containerClassName: useCheckerBoardBackground && classes.checkerBoardBackground,
    canvasSize: canvasSize,
    upload: mockUploadFunction,
    renderStandardToolbox: renderStandardToolbox,
    renderSelectionToolbox: renderSelectionToolbox,
    renderInlineToolbox: renderInlineToolbox,
    renderRulers: renderRulers,
    subtractSiblingsHeight: true,
    allowUpScaling: true,
    selectedColor: selectedColor,
    onContainerReady: containerReadyHandler,
    onContainerUpdate: containerUpdateHandler,
    EditorContainer: EditorContainerWithInjectedProps,
    renderInCanvasContainer: renderInCanvasContainer
  }));
};
Designer.defaultProps = {
  renderStandardToolbox: null,
  renderSelectionToolbox: null,
  renderInlineToolbox: null,
  show: true,
  hasBorder: true,
  renderRulers: null,
  selectedColor: '',
  hideDesigner: null,
  EditorContainer: CustomEditorContainer,
  useCheckerBoardBackground: false
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'Designer'
})((0, _AlignTargetProvider.withAlignTarget)(Designer));